export default __webpack_public_path__ + "static/media/35-min.1777ebc0.png";